import { authRequest } from './client';
import {
  type GasStationItem,
  type ListGasStationResponse,
  type UpdateGasStationInput,
} from './types';

// ─── backoffice-api gas station client ─────────────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/gas-station` endpoints
// (Feature 027). `listGasStation` is FINANCE_VIEWER, `updateGasStation` is
// CONFIG_MANAGER — mirrors assets.ts's shape.

export function listGasStation(): Promise<ListGasStationResponse> {
  return authRequest<ListGasStationResponse>('/gas-station');
}

export function updateGasStation(assetId: string, input: UpdateGasStationInput): Promise<GasStationItem> {
  return authRequest<GasStationItem>(`/gas-station/${assetId}`, { method: 'PATCH', body: JSON.stringify(input) });
}
